import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HiChevronLeft, HiXMark } from "react-icons/hi2";
import "./StepHeader.scss";

const StepHeader = ({ currentStep, totalSteps, stepTitle }) => {
    const navigate = useNavigate();
    const [showExitModal, setShowExitModal] = useState(false);

    const steps = [
        { number: 1, label: "Información" },
        { number: 2, label: "Tipo de Proyecto" },
        { number: 3, label: "Detalles del Alcance" },
        { number: 4, label: "Accesibilidad" },
    ];

    const handleBackClick = () => {
        setShowExitModal(true);
    };

    const handleConfirmExit = () => {
        sessionStorage.removeItem("projectEmail");
        navigate("/");
    };

    const handleCancelExit = () => {
        setShowExitModal(false);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape" && !showExitModal) {
                setShowExitModal(true);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [showExitModal]);

    return (
        <>
            <div className="step-header">
                <div className="step-header__container">
                    <button
                        className="step-header__breadcrumb"
                        onClick={handleBackClick}
                        aria-label="Volver al inicio"
                    >
                        <HiChevronLeft className="step-header__breadcrumb-icon" />
                        <span className="step-header__breadcrumb-text">
                            Volver al inicio
                        </span>
                    </button>

                    <div className="step-header__main">
                        <h1 className="step-header__title">{stepTitle}</h1>

                        <div className="step-progress">
                            {steps.map((step, index) => (
                                <React.Fragment key={step.number}>
                                    <div className="step-progress__item">
                                        <div
                                            className={`step-progress__circle ${
                                                step.number < currentStep
                                                    ? "step-progress__circle--completed"
                                                    : step.number ===
                                                      currentStep
                                                    ? "step-progress__circle--active"
                                                    : "step-progress__circle--pending"
                                            }`}
                                        >
                                            {step.number}
                                        </div>
                                        <span className="step-progress__label">
                                            {step.label}
                                        </span>
                                    </div>

                                    {index < steps.length - 1 && (
                                        <div
                                            className={`step-progress__line ${
                                                step.number < currentStep
                                                    ? "step-progress__line--completed"
                                                    : ""
                                            }`}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>

                    <div className="step-header__hint">
                        <kbd>ESC</kbd>
                        <span>para salir</span>
                    </div>
                </div>
            </div>

            {showExitModal && (
                <div className="exit-modal">
                    <div
                        className="exit-modal__overlay"
                        onClick={handleCancelExit}
                    />
                    <div className="exit-modal__content">
                        <button
                            className="exit-modal__close"
                            onClick={handleCancelExit}
                            aria-label="Cerrar"
                        >
                            <HiXMark />
                        </button>

                        <div className="exit-modal__icon">
                            <HiChevronLeft />
                        </div>

                        <h3 className="exit-modal__title">
                            ¿Salir del proyecto?
                        </h3>
                        <p className="exit-modal__text">
                            Se perderán todos los cambios que no hayas guardado.
                        </p>

                        <div className="exit-modal__actions">
                            <button
                                className="exit-modal__button exit-modal__button--cancel"
                                onClick={handleCancelExit}
                            >
                                Cancelar
                            </button>
                            <button
                                className="exit-modal__button exit-modal__button--confirm"
                                onClick={handleConfirmExit}
                            >
                                Sí, salir
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default StepHeader;
